module.exports = __webpack_public_path__ + "static/media/eye.2b4ccfbb.svg";